import { IHighlight } from '../models/highlight.interface';

export const HIGHLIGHTS: IHighlight[] = [
    {
        key: 'hightlight-1',
        description: 'Building websites using Angular and React frameworks.'
    },
    {
        key: 'hightlight-2',
        description: 'Creating HTML templates and styling with CSS (including using flexbox and animations)'
    },
    {
        key: 'hightlight-3',
        description: 'Creating a basic node express backend'
    },
    {
        key: 'hightlight-4',
        description: 'Back-end development with PHP using Symfony framework for the API and Doctrine for ORM'
    }
];